import { render, staticRenderFns } from "./ShipsPiWorkingEnvironment.vue?vue&type=template&id=9c60d008&scoped=true&"
import script from "./ShipsPiWorkingEnvironment.vue?vue&type=script&lang=js&"
export * from "./ShipsPiWorkingEnvironment.vue?vue&type=script&lang=js&"
import style0 from "./ShipsPiWorkingEnvironment.vue?vue&type=style&index=0&id=9c60d008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c60d008",
  null
  
)

export default component.exports